import React from 'react';
import PropTypes from 'prop-types';
import styles from "./ComponentInvoiceBlock.scss";
import Button from "../../common/primitives/Button";
import buttons from "../../common/primitives/Button.scss";
import {__t} from '../../common/lang/text-resource';

function ExistingCompanyInfo({companyInfo, editExistingCompany, allowEdit}) {
	let {
		company_tax_number,
		company_address,
		company_code,
		company_city,
		company_country,
		company_mol,
		company_eik,
		company_country_name_bg,
	} = companyInfo;
	let hasCompanyData = true;
	if (
	  company_tax_number === '' &&
	  company_address === '' &&
	  company_code === '' &&
	  company_city === '' &&
	  company_country === '' &&
	  company_mol === '' &&
	  company_eik === ''
	) {
		hasCompanyData = false;
	}
	if (allowEdit !== true || !hasCompanyData) {
		return null;
	}
	return (
	  <div className={styles.row}>
		  <div className={styles.firstCol}/>
		  <div className={`${styles.secondCol} ${styles.companyInfoContainer}`}>
			  <div className={styles.mb12}>
				  {company_eik !== '' && <div>{__t('ЕИК :eik', {eik: company_eik})}</div>}
				  {company_tax_number !== '' && company_tax_number !== company_eik &&
					<div>{__t('ДДС :dds', {dds: company_tax_number})}</div>}
			  </div>
			  <div className={styles.mb12}>
				  {company_address !== '' && <div>{company_address}</div>}
				  {
					(company_code !== '' || company_city !== '' || company_country !== '') &&
					<div>
						{company_code !== '' && `${company_code} `}
						{company_city !== '' && `${company_city}, `}
						{company_country !== '' && `${company_country_name_bg}`}
					</div>
				  }
			  </div>
			  <div className={styles.mbMol}>
				  {company_mol !== '' && <div>{__t('МОЛ :company_mol', {company_mol: company_mol})}</div>}
			  </div>
			  <div>
				  <Button
					onClick={editExistingCompany}
					name='editCompany'
					value={__t('Редактиране')}
					className={`${buttons.buttonLink} ${buttons.action} ${styles.editCompanyButton}`}/>
			  </div>

		  </div>
	  </div>
	)
}

ExistingCompanyInfo.defaultProps = {
	companyInfo: {
		company_tax_number: '',
		company_address: '',
		company_code: '',
		company_city: '',
		company_country: '',
		company_country_name_bg: '',
		company_country_name_en: '',
		company_mol: '',
		company_eik: '',
	},
	allowEdit: true
};
ExistingCompanyInfo.propTypes = {
	companyInfo: PropTypes.shape({
		company_tax_number: PropTypes.string,
		company_address: PropTypes.string,
		company_code: PropTypes.string,
		company_city: PropTypes.string,
		company_country: PropTypes.string,
		company_country_name_bg: PropTypes.string,
		company_country_name_en: PropTypes.string,
		company_mol: PropTypes.string,
		company_eik: PropTypes.string,
	}),
	editExistingCompany: PropTypes.func.isRequired,
	allowEdit: PropTypes.bool
};

export default ExistingCompanyInfo;
